import React from 'react';
import { motion } from 'framer-motion';
import './Agriculture.css';

const Agriculture: React.FC = () => {
  return (
    <div className="venture-page">
      <div className="venture-container">
        {/* Main Content */}
        <div className="venture-content">
          <motion.div
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
            className="venture-main-section"
          >
            <div className="venture-header">
              <div className="venture-header-background"
                style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/images/agriculture.jpg)` }}
              >
                <div className="venture-header-overlay">
                  <h2 className="section-main-title">Agriculture</h2>
                </div>
              </div>
            </div>
           

            <div className="venture-content-container">
              <motion.div
                initial={{ opacity: 0, x: -50 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.8 }}
                viewport={{ once: true }}
                className="venture-text-section"
              >
                <div className="venture-text-content">
                  <div className="venture-text">
                    
                    <h2 className="project-title">Ansuvara Agro Farm</h2>
                    <p>
                    As part of its long-term vision for sustainable growth and community development, Ansuvara Group is
                    launching Ansuvara Agro Farm, a major new venture focused on organic agriculture, agri-tourism, and
                    local empowerment. Spread across 330 ropanis in the scenic outskirts of Pokhara, this expansive farm
                    is designed to promote environmentally responsible farming practices while contributing to the region’s
                    agricultural innovation and food security.
                    Ansuvara Agro Farm will serve as a model for organic, chemical-free cultivation, integrating traditional
                    knowledge with modern techniques to deliver high-quality produce. The project also aims to create
                    economic opportunities for local communities through employment, training, and sustainable agri-
                    business models.
                    </p>
                    <p>
                    Open to visitors, the farm will feature interactive experiences and guided tours, allowing individuals,
                    families, and students to learn about sustainable agriculture firsthand. With this venture, Ansuvara
                    Group plans to further diversify its portfolio while supporting Nepal’s growing demand for clean,
                    traceable food sources and eco-conscious tourism.
                    </p>
                   

                    

                    <br/>
                    <br/>
                  </div>
                </div>
              </motion.div>
            </div>

          </motion.div>
        </div>
      </div>
    </div>
  );
};

export default Agriculture;

